import script from "./VenaScrap.vue?vue&type=script&setup=true&lang=js"
export * from "./VenaScrap.vue?vue&type=script&setup=true&lang=js"

import "./VenaScrap.vue?vue&type=style&index=0&id=0d4b8b5b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d4b8b5b"]])

export default __exports__